import React, { useState, useRef } from "react";

// Utils //
import rawToReact from "../../../utils/rawToReact";

// Styles //
import "./tableSelect.scss";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import ico_info from "../../../assets/images/icons/icon_11.svg";

interface TableSelectProps {
    content: any;
    setInputValue: (nombreId, value, type) => void;
    nombreId: string;
    type: string;
    setDuration: (value: string) => void;
    description: any;
    title: string;
    auxText: any;
    altText: any;
}

interface iSelectedOptions {id:number|null ; modality:string|null ; name:string};

const TableSelect = (props: TableSelectProps) => {
    const { content, setInputValue, nombreId, type, setDuration } = props;
    const [selectedOptions, setSelectedOptions ] = useState<iSelectedOptions>({id : null , modality: null , name: "" });

    const handleTallerSelection = (e, fila, index) => {

        setDuration(fila.fila[1].col);
        const strModality = fila.fila[2].col;
        const modalityList = strModality.split(/\s*,\s*/);
        let modality = modalityList.length == 1 ? modalityList[0] : null ;
        
        const selectedTaller = e.target.value;
        
        setSelectedOptions({id : index , modality , name: selectedTaller });
        if (modality ){
            setInputValue(nombreId, `${selectedTaller} - ${modality}`, type);
        } else {
            setInputValue(nombreId, "", type);
        }
    };

    return (
        <>
            {content && (
                <div>
                    <div className="table-select-header">
                        <h2>{props.title}</h2>
                        <span>{props.auxText}</span>
                        <div className="table-select-header-info">
                            {props.nombreId !== "workshop_offer" && 
                                <img 
                                    src={ico_info}
                                    alt="iconoInfo"
                                />
                            }
                            <div>
                                <div className="child-header-container">
                                    <img src="https://images.ctfassets.net/203frbsx1z3n/7smSES1AclVuOCzk12tkpg/4c38b0b5f9173600b11f2a1602e63026/computadora__1_.svg"/>
                                    <p className="child-header-container__text">Para tomar un taller en <strong>modalidad virtual</strong> necesitas acceso a internet y un dispositivo como una computadora o un celular para conectarte.</p>
                                </div>
                                <div className="child-header-container">
                                    <img src="https://images.ctfassets.net/203frbsx1z3n/2X5mCTar7xIsrCsF2L3Xn3/58b53a749c925d0ce7e59493695f9d3a/libro-alt__3_.svg"/>
                                    <p className="child-header-container__text">Para la <strong>modalidad presencial</strong> es importante que dispongas de tiempo y recursos para desplazarte al lugar en el que se dictará la formación.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="table-select">
                        <tbody>
                            <tr>
                                {content.cabecerasCol.map((cabecera, index) => {
                                    if (index == 3 ) return null;
                                    return <th key={index}>{cabecera.cabeceraName}</th>
                                })}
                            </tr>
                            {content.filas.map((fila, index) => (
                                <tr key={index}>
                                    <td className="input">
                                        <label>
                                            <input
                                                type="radio"
                                                name="talleres"
                                                value={fila.fila[0].col}
                                                className="a-nombre-taller-input"
                                                onChange={(e) => handleTallerSelection(e, fila, index)}
                                                id={fila.fila[0].col}
                                            />
                                            {fila.fila[0].col}
                                        </label>
                                    </td>
                                    <td>{fila.fila[1].col}</td>
                                    <td className="modality">
                                        {fila.fila[2].col ? (
                                            <>
                                                {(() => {
                                                    const modalities = fila.fila[2].col.split(", ");
                                                    return modalities.map((modality, idx) => {
                                                        if (modality === "Por definir") {
                                                            return (
                                                                <div className="a-modalidad-taller-info" key={idx}>
                                                                    <img src={ico_info} alt="iconoInfo" />
                                                                    <span>{modality}</span>
                                                                </div>
                                                            );
                                                        } else {
                                                            return (
                                                                <label key={idx}>
                                                                    <input
                                                                        type="radio"
                                                                        name={`modality-${idx}`}
                                                                        value={modality}
                                                                        className="a-modalidad-taller-input"
                                                                        onChange={(e) => {
                                                                            setInputValue(nombreId, `${selectedOptions.name} - ${e.target.value}`, type);
                                                                            setDuration(fila.fila[1].col);
                                                                            setSelectedOptions({id : index , modality , name: selectedOptions.name });
                                                                        }}
                                                                        id={`${modality.toLowerCase()}-${fila.fila[0].col}`}
                                                                        checked={selectedOptions.id == index && selectedOptions.modality == modality}
                                                                    />
                                                                    {modality}
                                                                </label>
                                                            );
                                                        }
                                                    });
                                                })()}
                                            </>
                                        ) : (
                                            <>
                                                {fila.fila[2].col.includes("Presencial") && (
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="modalidad"
                                                            value="Presencial"
                                                            className="a-modalidad-taller-input"
                                                            onChange={(e) => {
                                                                setInputValue(nombreId, `${selectedOptions.name} - ${e.target.value}`, type);
                                                                setDuration(fila.fila[1].col);
                                                                setSelectedOptions({id : index , modality : "Presencial" , name: selectedOptions.name });
                                                            }}
                                                            id={`presencial-${fila.fila[0].col}`}
                                                            checked={selectedOptions.id == index && selectedOptions.modality == "Presencial"}
                                                        />
                                                        Presencial
                                                    </label>
                                                )}
                                                {fila.fila[2].col.includes("Virtual") && (
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="modalidad"
                                                            value="Virtual"
                                                            className="a-modalidad-taller-input"
                                                            onChange={(e) => {
                                                                setInputValue(nombreId, `${selectedOptions.name} - ${e.target.value}`, type);
                                                                setDuration(fila.fila[1].col);
                                                                setSelectedOptions({id : index , modality : "Virtual" , name: selectedOptions.name });
                                                            }}
                                                            id={`virtual-${fila.fila[0].col}`}
                                                            checked={selectedOptions.id == index && selectedOptions.modality == "Virtual"}
                                                        />
                                                        Virtual
                                                    </label>
                                                )}
                                                {fila.fila[2].col.includes("Virtual Pregrabado") && (
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="modalidad"
                                                            value="Virtual pregrabado"
                                                            className="a-modalidad-taller-input"
                                                            onChange={(e) => {
                                                                setInputValue(nombreId, `${selectedOptions.name} - ${e.target.value}`, type);
                                                                setDuration(fila.fila[1].col);
                                                            }}
                                                            id={`virtual-pregrabado-${fila.fila[0].col}`}
                                                        />
                                                        Virtual pregrabado
                                                    </label>
                                                )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default TableSelect;
